/* ==========================================================================
   SearcherFli > Client > Prototype
   ========================================================================== */

/* Import modules */
const { Store } = require('@bluekiri/alexandria/helpers/state');

const { actions, types } = require('./store/actions');
const { reducer, reducerOpenjaw, reducerCrossSelling } = require('./store/reducer');

const { initCalendar, destroyCalendar } = require('./calendar');
const { initDestination, destroyDestination } = require('./destination');
const { initOrigin, destroyOrigin } = require('./origin');
const { initPassenger, destroyPassenger } = require('./passengers');
const { initProduct, destroyProduct } = require('./product');
const { initSubmit, destroySubmit } = require('./submit');
const { initAirlines, destroyAirlines } = require('./airlines');
const { initClasses, destroyClasses } = require('./classes');
const { initDiscount, destroyDiscount } = require('./discount');
const { initOptions, destroyOptions } = require('./options');
const { initFlightHotel, destroyFlightHotel } = require('./flight-hotel');
const { loadFromState } = require('./recover-state');

/* Prototype */
const prototype = {
    /* Setup store */
    setupStore() {
        if (this.store) return this;

        this.store = new Store({
            data: reducer,
            openjaw: reducerOpenjaw,
            crossSelling: reducerCrossSelling
        });

        return this;
    },
    /* Setup actions */
    setupActions() {
        if (this.actions) return this;

        this.actions = {
            destroy: () => {
                return this.store.dispatch(actions.destroy());
            },
            setSearcher: payload => {
                return this.store.dispatch(actions.setSearcher(payload));
            },
            addPaxesNames: payload => {
                return this.store.dispatch(actions.addPaxesNames(payload));
            },
            addTravelPolicy: payload => {
                return this.store.dispatch(actions.addTravelPolicy(payload));
            },
            addDirectFlights: payload => {
                return this.store.dispatch(actions.addDirectFlights(payload));
            }
        };

        return this;
    },
    /* Setup reactions */
    setupReactions() {
        if (this.reactions) return this;

        this.reactions = {
            destroy: this.store.subscribe((state, action) => {
                if (action.type !== types.DESTROY) return;

                /* Destroy */
                this.destroyComponents();

                /* Unsubscribe */
                this.unsubscribe();
                [...Object.keys(this.reactions)].forEach(key => this.reactions[key].unsubscribe());

                /* Clean DOM */
                this.element.parentNode.removeChild(this.element);

                /* Clean reference */
                [...Object.keys(this)].forEach(key => delete this[key]);
            })
        };

        return this;
    },
    /* Subscribe */
    subscribe() {
        if (this.subscriptions) this.unsubscribe();

        this.subscriptions = {};

        return this;
    },
    /* Unsubscribe */
    unsubscribe() {
        if (!this.subscriptions) return this;

        [...Object.keys(this.subscriptions)].forEach(key => this.subscriptions[key].unsubscribe());

        return this;
    },
    /* Components */
    initComponents() {
        /* Product */
        initProduct(this);

        /* Origin */
        initOrigin(this);

        /* Destination */
        initDestination(this);

        /* Calendar */
        initCalendar(this);

        /* Passenger */
        initPassenger(this);

        /* Submit */
        initSubmit(this);

        /* Airlines */
        initAirlines(this);

        /* Classes */
        initClasses(this);

        /* Discount */
        initDiscount(this);

        /* Options */
        initOptions(this);

        /* Cross selling */
        initFlightHotel(this);
    },
    destroyComponents() {
        /* Product */
        destroyProduct(this);

        /* Origin */
        destroyOrigin(this);

        /* Destination */
        destroyDestination(this);

        /* Calendar */
        destroyCalendar(this);

        /* Passenger */
        destroyPassenger(this);

        /* Submit */
        destroySubmit(this);

        /* Airlines */
        destroyAirlines(this);

        /* Classes */
        destroyClasses(this);

        /* Discount */
        destroyDiscount(this);

        /* Options */
        destroyOptions(this);

        /* Cross selling */
        destroyFlightHotel(this);
    },
    /* Init */
    init() {
        if (!this.config.init) return this;

        /* Setup store */
        this.setupStore();

        /* Setup actions */
        this.setupActions();

        /* Setup reactions */
        this.setupReactions();

        /* Subscribe */
        this.subscribe();

        /* Components */
        this.initComponents();

        /* Load state */
        loadFromState(this);

        return this;
    }
};

/* Exports */
module.exports = prototype;
